import React from "react";
import { Link } from "react-router-dom";

export default function BlogBoxHome({ blogdata }) {
  return (
    <>
      <div
        className="col-xl-4 col-lg-6 col-md-6 wow fadeInUp"
        data-wow-delay="0.3"
      >
        <div className="news-card-items-3">
          <div className="news-image">
            <img
              src={blogdata.sort_img}
              alt={blogdata.image_alt}
              title={blogdata.image_title}
            />
          </div>
          <div className="news-content">
            <h3>
              <Link to={`/blog/${blogdata.slug}`}>{blogdata.title}</Link>
            </h3>
            <Link to={`/blog/${blogdata.slug}`} className="link-btn">
              Read More{" "}
              <i className="fa fa-angle-double-right" aria-hidden="true"></i>
            </Link>
          </div>
        </div>
      </div>
    </>
  );
}
